'use client'
import { useWindowInfo, WindowInfoProvider } from '@faceless-ui/window-info'
export { useWindowInfo, WindowInfoProvider }
